<template>
  <BarChartForTopic
    v-bind:title="title"
    v-bind:data="data"
    v-bind:labels="labels"
    v-bind:ratio="labels.length > 10 ? true : false"
    width="3000"
    height="1000"
  />
</template>

<script>
import BarChartForTopic from "@/components/management/statistics/common/BarChartForTopic";
import { getAccessByTopicChartData } from "@/api/statisticsV2";

export default {
  components: {
    BarChartForTopic,
  },
  data() {
    return {
      title: "Access by Topic",
      data: [],
      labels: [],
    };
  },
  methods: {
    async getData(startDate, endDate) {
      let loader = this.$loading.show({});
      try {
        let response = await getAccessByTopicChartData(startDate, endDate);
        this.labels = response.data.name;
        this.data = response.data.count;
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style></style>
